var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.$style.example_content_item] },
    [
      _vm.showForm
        ? _c("core-popup", {
            attrs: {
              "close-icon": true,
              show: _vm.showForm,
              title: _vm.locale("" + _vm.title),
              width: 396,
            },
            on: { onClickCancel: _vm.toggleForm },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("ValidationObserver", {
                        ref: "form",
                        attrs: { tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var handleSubmit = ref.handleSubmit
                                return [
                                  _c("div", { class: _vm.$style.report_form }, [
                                    _c(
                                      "div",
                                      { class: _vm.$style.report_form_element },
                                      [
                                        _vm.calculationDropdownItems.length
                                          ? _c("vgp-label-slot", {
                                              style: { marginBottom: "16px" },
                                              attrs: {
                                                label: _vm.locale(
                                                  "reports_pages_model_of_calc"
                                                ),
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "body",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "vgp-dropdown-select",
                                                          {
                                                            attrs: {
                                                              "drop-list":
                                                                _vm.calculationDropdownItems,
                                                              "highlight-active-state": false,
                                                              "show-selected-first": false,
                                                              "show-reset-btn": false,
                                                              multiselect: false,
                                                              "track-by-item-tooltip":
                                                                "tooltip",
                                                              "group-by":
                                                                "group",
                                                              "item-template":
                                                                "text",
                                                              "track-by-text":
                                                                "text",
                                                              size: "autoWidth",
                                                              selected:
                                                                _vm.calculationMode,
                                                            },
                                                            on: {
                                                              selected:
                                                                _vm.changeCalculationMode,
                                                            },
                                                          }
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("vgp-label-slot", {
                                          attrs: {
                                            label: _vm.hasPortfoliosTab
                                              ? _vm.locale(
                                                  "report_form_select_projects_or_multiview"
                                                )
                                              : _vm.locale(
                                                  "report_form_select_projects"
                                                ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "body",
                                                fn: function () {
                                                  return [
                                                    _vm.hasPortfoliosTab
                                                      ? _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.$style
                                                                .reports_form_tabs,
                                                          },
                                                          [
                                                            _c("vgp-tabs", {
                                                              attrs: {
                                                                tabs: _vm.tabsItems,
                                                                active:
                                                                  _vm.activeFormTab,
                                                                type: "button",
                                                              },
                                                              on: {
                                                                onToggle:
                                                                  _vm.toggleTab,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.activeFormTab.id === 1
                                                      ? _c(
                                                          "ValidationProvider",
                                                          {
                                                            ref: "selectedProjectsValidationProvider",
                                                            attrs: {
                                                              rules: "required",
                                                              vid: "selectedProjects",
                                                              "custom-messages":
                                                                {
                                                                  required:
                                                                    _vm.locale(
                                                                      "error_required_field"
                                                                    ),
                                                                },
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "vgp-dropdown-select",
                                                                        {
                                                                          ref: "selectedProjects",
                                                                          staticClass:
                                                                            "dropdown",
                                                                          class:
                                                                            [
                                                                              _vm
                                                                                .$style
                                                                                .vgp_select,
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              placeholder:
                                                                                _vm.locale(
                                                                                  "reports_pages_projects_dropdown_placeholder"
                                                                                ),
                                                                              "highlight-active-state": false,
                                                                              "use-search": true,
                                                                              "show-selected-first": true,
                                                                              "show-reset-btn": false,
                                                                              selected:
                                                                                _vm.selectedProjects,
                                                                              "drop-list":
                                                                                _vm.projects,
                                                                              "item-template":
                                                                                "text",
                                                                              "use-select-all":
                                                                                _vm.hasMultiSelect,
                                                                              multiselect:
                                                                                _vm.hasMultiSelect,
                                                                              "track-by-text":
                                                                                "name",
                                                                              size: "autoWidth",
                                                                              "need-description": false,
                                                                            },
                                                                          on: {
                                                                            selected:
                                                                              _vm.changeSelectProjects,
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.selectedProjects,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.selectedProjects =
                                                                                    $$v
                                                                                },
                                                                              expression:
                                                                                "selectedProjects",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      errors[0]
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              class:
                                                                                _vm
                                                                                  .$style
                                                                                  .error,
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                    " +
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  ) +
                                                                                  "\n                  "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        )
                                                      : _c(
                                                          "ValidationProvider",
                                                          {
                                                            ref: "selectedMultiviewValidationProvider",
                                                            attrs: {
                                                              rules: "required",
                                                              vid: "selectedMultiview",
                                                              "custom-messages":
                                                                {
                                                                  required:
                                                                    _vm.locale(
                                                                      "error_required_field"
                                                                    ),
                                                                },
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "vgp-dropdown-select",
                                                                        {
                                                                          ref: "selectedProjects",
                                                                          staticClass:
                                                                            "dropdown",
                                                                          class:
                                                                            [
                                                                              _vm
                                                                                .$style
                                                                                .vgp_select,
                                                                            ],
                                                                          attrs:
                                                                            {
                                                                              placeholder:
                                                                                _vm.locale(
                                                                                  "reports_pages_projects_dropdown_placeholder"
                                                                                ),
                                                                              "highlight-active-state": false,
                                                                              "use-search": true,
                                                                              "show-selected-first": true,
                                                                              "show-reset-btn": false,
                                                                              selected:
                                                                                _vm.selectedMultiview,
                                                                              "drop-list":
                                                                                _vm.multiviews,
                                                                              "item-template":
                                                                                "text",
                                                                              multiselect: false,
                                                                              "track-by-text":
                                                                                "name",
                                                                              size: "autoWidth",
                                                                              "need-description": false,
                                                                              "popup-max-height": 200,
                                                                            },
                                                                          on: {
                                                                            selected:
                                                                              _vm.changeSelectMultiview,
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.selectedMultiview,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.selectedMultiview =
                                                                                    $$v
                                                                                },
                                                                              expression:
                                                                                "selectedMultiview",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      errors[0]
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              class:
                                                                                _vm
                                                                                  .$style
                                                                                  .error,
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                    " +
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  ) +
                                                                                  "\n                  "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _vm.isShowBaselineNotification
                                          ? _c(
                                              "div",
                                              { style: { paddingTop: "16px" } },
                                              [
                                                _c("inline-notification", {
                                                  attrs: {
                                                    type: "warning",
                                                    text: _vm.warningMessage,
                                                    "message-styles": {
                                                      "font-size": "12px",
                                                      "white-space": "normal",
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { class: [_vm.$style.form_line_buttons] },
                                    [
                                      _c("vgp-button", {
                                        attrs: {
                                          type: "primary",
                                          small: false,
                                          label:
                                            _vm.locale("report_create_btn"),
                                          disabled: _vm.disabledButton,
                                        },
                                        on: {
                                          onClick: function ($event) {
                                            return handleSubmit(
                                              _vm.onClickSubmit
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1141733052
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3686017179
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }